import * as L from 'leaflet';
import Masonry from 'masonry-layout';
import imagesLoaded from 'imagesloaded';

export class SingleAdresse {
  // Map
  private mapElement: HTMLElement | null;
  private lat: number = 0;
  private lng: number = 0;
  private iconUrl?: string;
  private mapInstance: L.Map | null = null;

  // Masonry
  private gridElement: HTMLElement | null;
  private masonryInstance: Masonry | null = null;
  private readonly breakpoint = 1025;
  private resizeTimer: number | null = null;

  constructor() {
    this.mapElement = document.querySelector('[data-map-single-adresse]') as HTMLElement | null;

    if (this.mapElement) {
      this.initMap();
    }

    this.gridElement = document.querySelector('[data-gallery-single-adresse]') as HTMLElement | null;
    if (this.gridElement) {
      this.initGallery();
    }
  }

  private async initMap(): Promise<void> {
    if (!this.parseDataAttributes()) {
      return;
    }
    try {
      const L = await import('leaflet');
      if (this.mapInstance) {
        this.mapInstance.remove();
      }

      this.mapInstance = L.map(this.mapElement!).setView([this.lat, this.lng], 15);

      L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
      }).addTo(this.mapInstance);


      const customIcon = L.icon({
        iconUrl: this.iconUrl,
        iconSize: [24, 24],
        iconAnchor: [24, 24],
      });

      L.marker([this.lat, this.lng], { icon: customIcon }).addTo(this.mapInstance);
    } catch (error) {
      console.error("[Single Adresse] Erreur lors du chargement ou de l'initialisation de Leaflet :", error);
    }
  }

  private parseDataAttributes(): boolean {
    const data = this.mapElement!.dataset;

    this.lat = parseFloat(data.lat || '0');
    this.lng = parseFloat(data.lng || '0');
    this.iconUrl = data.iconUrl;

    if (isNaN(this.lat) || isNaN(this.lng)) {
      console.error('[Single Adresse] Coordonnées de la carte invalides.');
      return false;
    }
    return true;
  }

  private initGallery() {

    const handleResize = () => this.toggleMasonryState();

    window.addEventListener('resize', () => {
      if (this.resizeTimer) clearTimeout(this.resizeTimer);
      this.resizeTimer = window.setTimeout(handleResize, 250);
    });
    this.toggleMasonryState();
  }

  private toggleMasonryState(): void {
    if (!this.gridElement) return;

    const isMobile = window.innerWidth < this.breakpoint;
    const isInitialized = !!this.masonryInstance;

    if (isMobile && !isInitialized) {
      imagesLoaded(this.gridElement, () => {
        this.masonryInstance = new Masonry(this.gridElement!, {
          itemSelector: '.grid-item',
          columnWidth: '.grid-sizer',
          percentPosition: true,
          gutter: 8
        });
      });
    }

    else if (!isMobile && isInitialized) {
      this.masonryInstance?.destroy();
      this.masonryInstance = null;
    }
  }
}
export const singleAdresse = new SingleAdresse();